import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "card-header" }

import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { ArrowLeft, User, Lock } from '@element-plus/icons-vue';
import { login } from '@/user/api/auth';
import { useStore } from 'vuex';
import GlobalChatWebSocketService from '@/user/services/globalChatService'; // 导入全局WebSocket服务
import { initWebSocketNotifications } from '@/user/services/notificationService'; // 导入WebSocket通知初始化函数

interface LoginForm {
  username: string;
  password: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter();
const store = useStore();

const loginForm = reactive<LoginForm>({
  username: '',
  password: ''
});

const loading = ref(false);

const validateUsername = (rule: any, value: any, callback: any) => {
  if (!value) {
    callback(new Error('请输入用户名'));
  } else {
    callback();
  }
};

const validatePassword = (rule: any, value: any, callback: any) => {
  if (!value || value.length < 6) {
    callback(new Error('密码长度至少为6位'));
  } else {
    callback();
  }
};

const rules = reactive({
  username: [{ validator: validateUsername, trigger: 'blur' }],
  password: [{ validator: validatePassword, trigger: 'blur' }]
});

const loginFormRef = ref();

const handleLogin = async () => {
  // 验证表单
  if (!loginFormRef.value) return;
  
  const valid = await loginFormRef.value.validate().catch(() => false);
  if (!valid) return;

  loading.value = true;
  
  try {
    const response = await login(loginForm);
    
    console.log('登录响应:', response); // 添加调试信息
    
    // 检查响应格式
    let loginResult;
    
    // 根据项目规范，后端响应可能有两种格式：
    // 1. 直接是 { code: 1, data: {...}, msg: "..." } 格式
    // 2. 嵌套格式 { data: { code: 1, data: {...}, msg: "..." } }
    
    if (response && typeof response === 'object') {
      if (response.code === 1) {
        // 直接是期望的成功格式
        loginResult = response;
      } else if (response.code !== 1) {
        // 登录失败，直接抛出后端返回的错误信息
        throw new Error(response.msg || '登录失败');
      } else if (response.data && response.data.code === 1) {
        // 嵌套格式
        loginResult = response.data;
      } else if (response.data && response.data.code !== 1) {
        // 嵌套格式的失败响应
        throw new Error(response.data.msg || '登录失败');
      } else {
        // 既不是直接格式也不是嵌套格式
        throw new Error('登录响应格式不正确');
      }
    } else {
      throw new Error('登录响应格式不正确');
    }
    
    // 获取用户数据
    const userData = loginResult.data;
    
    // 验证必需的字段
    if (!userData || !userData.token) {
      throw new Error('登录响应缺少必要数据');
    }
    
    // 将用户信息存储到store
    store.dispatch('setUserInfo', {
      id: userData.id,
      username: userData.username,
      name: userData.name,
      avatar: userData.avatar,
      roleId: userData.roleId
    });
    
    // 存储token到store和localStorage
    store.commit('SET_TOKEN', userData.token);
    localStorage.setItem('token', userData.token);
    
    ElMessage.success('登录成功');
    
    // 登录成功后立即启动WebSocket连接
    console.log('准备启动WebSocket连接...');
    GlobalChatWebSocketService.connect(userData.token);
    
    // 初始化WebSocket通知处理器，确保能接收公告和通知消息
    initWebSocketNotifications();
    
    // 跳转到首页
    await router.push({ name: 'home' });
  } catch (error: any) {
    console.error('登录错误:', error);
    // 显示具体的错误信息
    ElMessage.error(error.message || error.response?.data?.msg || error.message || '登录失败');
  } finally {
    loading.value = false;
  }
};

const goBackToHome = () => {
  router.push({ name: 'home' });
};

const goToRegister = () => {
  router.push({ name: 'register' });
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "yarn-ball-decoration" }, null, -1)),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "yarn-ball-decoration secondary" }, null, -1)),
    _createVNode(_component_el_card, { class: "login-card" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            icon: _unref(ArrowLeft),
            type: "default",
            onClick: goBackToHome,
            plain: false,
            class: "back-button"
          }, null, 8, ["icon"]),
          _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "login-title" }, "🧵 登录到钩织乐园", -1))
        ]),
        _createVNode(_component_el_form, {
          model: loginForm,
          rules: rules,
          ref_key: "loginFormRef",
          ref: loginFormRef,
          "label-width": "0px",
          class: "login-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "username" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: loginForm.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.username) = $event)),
                  "prefix-icon": _unref(User),
                  placeholder: "请输入用户名",
                  size: "large"
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: loginForm.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.password) = $event)),
                  "prefix-icon": _unref(Lock),
                  type: "password",
                  placeholder: "请输入密码",
                  size: "large",
                  onKeyup: _withKeys(handleLogin, ["enter"])
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "large",
                  onClick: handleLogin,
                  loading: loading.value,
                  class: "login-btn"
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" 登录 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }),
            _createElementVNode("div", { class: "register-hint" }, [
              _createElementVNode("p", null, [
                _cache[4] || (_cache[4] = _createTextVNode("还没有账号？", -1)),
                _createElementVNode("a", {
                  onClick: goToRegister,
                  class: "link"
                }, "立即注册")
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    })
  ]))
}
}

})